import React, { useRef, useState, useEffect, useCallback } from "react";
import axios from "axios";
import { motion, number } from "framer-motion";
import "./KanbanBoard.css";
import TaskDetailsPopup from '../TaskDetailsPopup/TaskDetailsPopup';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';
import 'react-toastify/dist/ReactToastify.css';
import DatePicker from 'react-datepicker'
import "react-datepicker/dist/react-datepicker.css";
import ListView from "./Listview";

import Swal from 'sweetalert2';
import {
  DndContext,
  closestCenter,
  MouseSensor,
  TouchSensor,
  KeyboardSensor,
  useSensor,
  useSensors,
  DragOverlay,
  PointerSensor,
  useDroppable 
} from "@dnd-kit/core";
import {
  arrayMove,
  SortableContext,
  useSortable,
  verticalListSortingStrategy,
  horizontalListSortingStrategy
} from "@dnd-kit/sortable";
import { toast } from "react-toastify";
import { minHeight, styled } from "@mui/system";
import { CSS } from "@dnd-kit/utilities";
import ScrollContainer from 'react-indiana-drag-scroll'
import Pusher from "pusher-js";


const KanbanBoard = ({ filters }) => {
    const [viewMode, setViewMode] = useState("board");
    const [addingTask, setAddingTask] = useState(null);
    const [buckets, setBuckets] = useState([]);
    const [tasks, setTasks] = useState([]);
    const [logs,setLogs] = useState([])
    const [users,setUsers] = useState([])
    const [userMap,setUserMap] = useState([])
    const [taskUsers,setTaskUsers] = useState([])
    const [menuOpen, setMenuOpen] = useState(null);
    const [taskMenuOpen, setTaskMenuOpen] = useState(null);
    const [editingBucket, setEditingBucket] = useState(null);
    const [newBucketName, setNewBucketName] = useState("");
    const [addingBucket, setAddingBucket] = useState(false);
    const [deleteConfirm, setDeleteConfirm] = useState(null);
    const [newTask, setNewTask] = useState({ name: "", dueDate: "", assignedTo: [], assigneeInput: "", bucketId: null });
    const [editingTaskId, setEditingTaskId] = useState(null);
    const [taskEdits, setTaskEdits] = useState({ name: "", due_date: "", assignedTo: [], assigneeInput: "" });
    const [removedAssignees,setRemovedAssignees] = useState([])
    const [loading, setLoading] = useState(true);
    const [reload,setReload] = useState(true)
    const [taskLoading, setTaskLoading] = useState(false);
    const [error, setError] = useState(null);
    const [userSuggestions, setUserSuggestions] = useState([]);
    const [selectedTask, setSelectedTask] = useState(null);
    const boardRef = useRef(null);
    const userData = JSON.parse(localStorage.getItem("user"));
    const [currentUser, setCurrentUser] = useState(userData);
    const wrapperRef = useRef();
    const bucketMenuRef = useRef(null);
    const [openCompleted, setOpenCompleted] = useState({});
    const [showDateInput, setShowDateInput] = useState(false);
    const [selectedDate,setSelectedDate] = useState(null)
    const [showAssigneeInput, setShowAssigneeInput] = useState(false);
    const [deleteTaskConfirm, setDeleteTaskConfirm] = useState(null);
    const [shownImages, setShownImages] = useState(() => {
        const saved = localStorage.getItem('shownImages');
        return saved ? JSON.parse(saved) : {};
    });
    const [showCard,setShowCard] = useState();
    const [activeTask, setActiveTask] = useState(null);
    const [activeBucket, setActiveBucket] = useState(null);
    const [active, setActive] = useState(null); 
    const [isDraggingBucket, setIsDraggingBucket] = useState(false);
    const [deletedTask, setDeletedTask] = useState(null);
    const [showUndo, setShowUndo] = useState(false);
    const [dragTasks, setDragTasks] = useState(null)
    const [draggingTask, setDraggingTask] = useState(null);
    const [assigningUser,setAssigningUser] = useState(false)
    const containerRef = useRef(null);
    const [isDragging, setIsDragging] = useState(false);
    const [startX, setStartX] = useState(0);
    const [scrollLeft, setScrollLeft] = useState(0);
    const [moved, setMoved] = useState(false);

    // ✅ FIX: Keep a stable ref to setSelectedTask for use inside Pusher callbacks
    const setSelectedTaskRef = useRef(setSelectedTask);
    useEffect(() => {
        setSelectedTaskRef.current = setSelectedTask;
    }, [setSelectedTask]);


// safe avatar URL (prefix backend host if needed)
const getAvatarUrl = (user) => {
  if (!user) return "/default-avatar.png";
  const pic = user.profile_pic || "";
  return pic.startsWith("http") ? pic : `https://teams.tidyds.com${pic}`;
};
    const onMouseDown = (e) => {
        setIsDragging(true);
        setMoved(false);
        setStartX(e.pageX - containerRef.current.offsetLeft);
        setScrollLeft(containerRef.current.scrollLeft);
    };
    const applyFilters = (task) => {
  if (!filters) return true;

  // 📅 Due Date
  if (filters.dueDate) {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    if (!task.due_date) {
      return filters.dueDate === "no_date"; // only show in "No date"
    }

    // Convert DB string to JS Date
    const dueDate = new Date(task.due_date);
    dueDate.setHours(0, 0, 0, 0);

    const diffInDays = Math.floor((dueDate - today) / (1000 * 60 * 60 * 24));

    switch (filters.dueDate) {
      case "late": // yesterday or earlier
        return dueDate < today;

      case "today":
        return diffInDays === 0;

      case "tomorrow":
        return diffInDays === 1;

      case "this_week": {
        const dayOfWeek = today.getDay(); // 0 = Sunday
        const daysUntilEndOfWeek = 6 - dayOfWeek;
        return diffInDays >= 0 && diffInDays <= daysUntilEndOfWeek;
      }

      case "next_week": {
        const dayOfWeek = today.getDay();
        const daysUntilNextWeek = 7 - dayOfWeek;
        return diffInDays >= daysUntilNextWeek && diffInDays <= daysUntilNextWeek + 6;
      }

      case "future": {
        const dayOfWeek = today.getDay();
        const daysUntilNextWeek = 7 - dayOfWeek;
        return diffInDays > daysUntilNextWeek + 6;
      }

      case "no_date":
        return !task.due_date;

      default:
        return true;
    }
  }

  // 🔥 Priority
  if (
    filters.priority &&
    task.priority?.toLowerCase() !== filters.priority.toLowerCase()
  ) {
    return false;
  }

  // 📊 Progress
  if (
    filters.progress &&
    task.status?.toLowerCase() !== filters.progress.toLowerCase()
  ) {
    return false;
  }

  // 🪣 Bucket
  if (filters.bucket && task.bucket_id !== filters.bucket) {
    return false;
  }

  // 👤 Assignment
  if (filters.assignment) {
    const assignedUsers = task.assigned_users?.map((u) => u.id) || [];
    if (!assignedUsers.includes(filters.assignment)) return false;
  }

  return true;
};


    const onMouseLeave = () => setIsDragging(false);

    const onMouseUp = () => {
        setIsDragging(false);
    };

    const onMouseMove = (e) => {
    if (!isDragging) return;
        e.preventDefault();
        const x = e.pageX - containerRef.current.offsetLeft;
        const walk = (x - startX) * 1; // speed factor
        if (Math.abs(walk) > 5) {
            setMoved(true);
        }
        containerRef.current.scrollLeft = scrollLeft - walk;
    };

    const sensors = useSensors(
        useSensor(MouseSensor, { activationConstraint: { distance: 8 } }), 
        useSensor(TouchSensor, { activationConstraint: { delay: 150, tolerance: 5 } }),
        useSensor(KeyboardSensor),
        useSensor(PointerSensor, {
      activationConstraint: { distance: 5 }, // prevents accidental drags
    })
    );

    useEffect(() => {
        if (selectedTask) {
            document.body.classList.add("modal-open");
        } else {
            document.body.classList.remove("modal-open");
        }
    }, [selectedTask]);



    useEffect(() => {
        const fetchData = async () => {
            try {
                await fetchBuckets();
                await fetchTasks();
                await fetchUserSuggestions("");
                await fetchLogs();
                await fetchUsers();
                await fetchTaskUsers();
            } catch (err) {
                setError("Failed to load data");
            } finally {
                setLoading(false);
            }
        };
        fetchData();
    }, []);


    // ✅ FIX: Single consolidated Pusher useEffect — replaces all 5 separate ones
    useEffect(() => {
        const pusher = new Pusher("fc220368b01ca08f708b", {
            cluster: "ap2",
        });

        // ─── Tasks channel ────────────────────────────────────────────
        const taskChannel = pusher.subscribe("tasks");

        taskChannel.bind("task.updated", (data) => {
            const updatedTask = data.task;

            setTasks((prev) => {
                if (!prev || typeof prev !== "object") return prev;

                const updatedTasks = { ...prev };
                const bucketId = updatedTask.bucket_id;

                // Remove from all buckets first
                for (const bId in updatedTasks) {
                    updatedTasks[bId] = updatedTasks[bId].filter(t => t.id !== updatedTask.id);
                }

                if (!updatedTasks[bucketId]) {
                    updatedTasks[bucketId] = [updatedTask];
                    return updatedTasks;
                }

                const existingIndex = updatedTasks[bucketId].findIndex(
                    (t) => t.id === updatedTask.id
                );

                if (existingIndex !== -1) {
                    updatedTasks[bucketId][existingIndex] = updatedTask;
                } else {
                    updatedTasks[bucketId].push(updatedTask);
                    updatedTasks[bucketId].sort((b, a) => a.position - b.position);
                }

                return updatedTasks;
            });

            // ✅ KEY FIX: Update the open popup in-place — no remount, no flicker
            setSelectedTaskRef.current((prev) =>
                prev?.id === updatedTask.id ? updatedTask : prev
            );

            // Update taskUsers to reflect backend assigned users
            setTaskUsers((prev) => ({
                ...prev,
                [updatedTask.id]: updatedTask.assigned_users?.map(u => u.id) || []
            }));
        });

        taskChannel.bind("task.moved", (data) => {
            const movedTask = data.task;

            setTasks((prev) => {
                if (!prev || typeof prev !== "object") return prev;

                const updatedTasks = { ...prev };
                const bucketId = movedTask.bucket_id;

                for (const bId in updatedTasks) {
                    updatedTasks[bId] = updatedTasks[bId].filter(
                        (t) => t.id !== movedTask.id
                    );
                }

                if (!updatedTasks[bucketId]) {
                    updatedTasks[bucketId] = [];
                }

                updatedTasks[bucketId].push(movedTask);

                updatedTasks[bucketId].sort((a, b) => {
                    if (a.position !== undefined && b.position !== undefined) {
                        return b.position - a.position;
                    }
                    return b.id - a.id;
                });

                return updatedTasks;
            });

            // ✅ Keep popup in sync if this moved task is open
            setSelectedTaskRef.current((prev) =>
                prev?.id === movedTask.id ? movedTask : prev
            );
        });

        taskChannel.bind("task.created", (data) => {
            setTasks((prev) => {
                const updated = { ...prev };
                const bucketId = data.task.bucket_id;
                if (!updated[bucketId]) updated[bucketId] = [];
                updated[bucketId].unshift(data.task);
                return updated;
            });
        });

        taskChannel.bind("task.deleted", ({ taskId, bucketId }) => {
            setTasks(prev => {
                if (!prev) return prev;
                const updated = { ...prev };
                if (updated[bucketId]) {
                    updated[bucketId] = updated[bucketId].filter(t => t.id !== taskId);
                }
                return updated;
            });
            // ✅ Close popup if the deleted task is currently open
            setSelectedTaskRef.current((prev) =>
                prev?.id === taskId ? null : prev
            );
        });

        // ─── Logs channel ─────────────────────────────────────────────
        const logChannel = pusher.subscribe("logs");
        logChannel.bind("log.created", (log) => {
            setLogs(prevLogs => [log, ...(prevLogs || [])]);
        });

        // ─── Buckets channel ──────────────────────────────────────────
        const bucketChannel = pusher.subscribe("buckets");

        bucketChannel.bind("bucket.created", (data) => {
            setBuckets((prev) => [...prev, data.bucket].sort((a, b) => a.position - b.position));
        });

        bucketChannel.bind("bucket.moved", (data) => {
            const { bucket } = data;
            if (!bucket) return;

            setBuckets((prevBuckets) => {
                if (!Array.isArray(prevBuckets)) return prevBuckets;
                const updatedBuckets = prevBuckets.map((b) =>
                    b.id === bucket.id ? { ...b, position: bucket.position } : b
                );
                return updatedBuckets.sort((a, b) => a.position - b.position);
            });
        });

        bucketChannel.bind("bucket.deleted", ({ bucketId }) => {
            setBuckets(prev => prev.filter(b => b.id !== bucketId));
        });

        return () => {
            taskChannel.unbind_all();
            logChannel.unbind_all();
            bucketChannel.unbind_all();
            pusher.unsubscribe("tasks");
            pusher.unsubscribe("logs");
            pusher.unsubscribe("buckets");
            pusher.disconnect();
        };
    }, []); // ✅ Empty deps — one single connection for the lifetime of the component


    useEffect(() => {
        localStorage.setItem('shownImages', JSON.stringify(shownImages));
    }, [shownImages]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (bucketMenuRef.current && !bucketMenuRef.current.contains(event.target)) {
                setMenuOpen(null); // Close bucket dropdown
            }
        };  
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [menuOpen]);
    useEffect(() => {
        const board = boardRef.current;
        if (!board) return;
      
        let isDown = false;
        let startX;
        let scrollLeft;
      
        const handleMouseDown = (e) => {
            isDown = true;
            board.classList.add('active');
            startX = e.pageX - board.offsetLeft;
            scrollLeft = board.scrollLeft;         
            document.body.style.userSelect = 'none'; // Disable text selection completely
          };
      
        const handleMouseLeave = () => {
          isDown = false;
          board.classList.remove('active');
          document.body.style.userSelect = 'auto'; // Enable back
        };
      
        const handleMouseUp = () => {
            isDown = false;
            board.classList.remove('active');
            document.body.style.userSelect = 'auto'; // Enable back
          };
          
      
        const handleMouseMove = (e) => {
            if (!isDown) return;
            e.preventDefault();  // Important to stop text selection & other default behaviors
            const x = e.pageX - board.offsetLeft;
            const walk = (x - startX) * 2;
            board.scrollLeft = scrollLeft - walk;
        };
      
        board.addEventListener('mousedown', handleMouseDown);
        board.addEventListener('mouseleave', handleMouseLeave);
        board.addEventListener('mouseup', handleMouseUp);
        board.addEventListener('mousemove', handleMouseMove);
      
        return () => {
          board.removeEventListener('mousedown', handleMouseDown);
          board.removeEventListener('mouseleave', handleMouseLeave);
          board.removeEventListener('mouseup', handleMouseUp);
          board.removeEventListener('mousemove', handleMouseMove);
        };
      }, []);      
    
    useEffect(() => {
        const handleClickOutside = () => setTaskMenuOpen(null);
        document.addEventListener('click', handleClickOutside);
        return () => document.removeEventListener('click', handleClickOutside);
    }, []);
      


    const fetchBuckets = async () => {
        const response = await axios.get("https://teams.tidyds.com/api/buckets");
        setBuckets(response.data);
    };

    const fetchTasks = async () => {
        const response = await axios.get("https://teams.tidyds.com/api/tasks");
        const taskMap = response.data.reduce((acc, task) => {
            acc[task.bucket_id] = acc[task.bucket_id] || [];
            acc[task.bucket_id].unshift(task);
            return acc;
        }, {});
        setTasks(taskMap);
    };
    
    const fetchUserSuggestions = async (query) => {
        try {
            const res = await axios.get('https://teams.tidyds.com/api/users/search?q=' + query);
            const usersWithFullPic = res.data.map(user => ({
                ...user,
                profile_pic: `https://teams.tidyds.com${user.profile_pic}` // Always prepending because profile_pic is like "uploads/..."
            }));
            setUserSuggestions(usersWithFullPic);
            
        } catch (error) {
            console.error(error);
        }
    };
    
    const fetchLogs = async () => {
        try {
            const response = await fetch('https://teams.tidyds.com/api/logs');
            const data = await response.json();
            setLogs(data);
        } catch (error) {
            console.error('Failed to fetch logs:', error);
        }
    };
    
    const fetchUsers = async ()=>{
        try {
            const response = await fetch('https://teams.tidyds.com/api/users');
            const data = await response.json();
            setUsers(data);
            const map = {}
            data.forEach(u => {
                map[u.id] = u.name;
            });
            setUserMap(map)
        } catch (error) {
            console.error('Failed to fetch Users:', error);
        }
    }

    const fetchTaskUsers = async() =>{
        try{
            const response = await fetch("https://teams.tidyds.com/api/task-users");
            const data = await response.json();
            const taskUserMap = data.reduce((acc, item) => {
                if (!acc[item.task_id]) {
                    acc[item.task_id] = [];
                }
                acc[item.task_id].push(item.user_id);
                return acc;
            }, {})
            setTaskUsers(taskUserMap);
            }catch(error){
                console.log("Failed to fetch Task Users:",error)
            }
        }

            const taskElementId = (bucketId, taskId) => `task-${bucketId}-${taskId}`;
            const bucketElementId = (bucketId) => `bucket-${bucketId}`;

    function parseElementId(id) {
            const parts = String(id).split("-");
            if (parts[0] === "task") {
                return { type: "task", bucketId: parts[1], taskId: parts[2] };
            }
            if (parts[0] === "bucket") {
                return { type: "bucket", bucketId: parts[1] };
            }
            return { type: "unknown" };
    }


    const formatDate = (dateStr) => {
        if (!dateStr) return ""; 

        const date = new Date(dateStr);
        if (isNaN(date)) return ""; 

        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0"); 
        const year = date.getFullYear();

        return `${day}/${month}/${year}`; // DD/MM/YYYY
    };


    const addBucket = async () => {
        setAddingBucket(false);
        if (!newBucketName.trim()) return;
        try {
            const response = await axios.post("https://teams.tidyds.com/api/buckets", { name: newBucketName });
            setBuckets([response.data,...buckets]);
            setNewBucketName("");
        } catch (error) {
            console.error("Error adding bucket:", error);
        }
    };

    const toggleMenu = (bucketId) =>{
        document.activeElement?.blur();
        setMenuOpen(menuOpen === bucketId ? null : bucketId);
    }
    const toggleTaskMenu = (taskId) =>{
        document.activeElement?.blur();
        setTaskMenuOpen(taskMenuOpen === taskId ? null : taskId);
    }

    const handleEditBucket = (bucket) => {
        setEditingBucket(bucket.id);
        setNewBucketName(bucket.name);
        setMenuOpen(null);
    };

    const saveEditedBucket = async (bucketId) => {
        if (!newBucketName.trim()) return;
        try {
            await axios.put(`https://teams.tidyds.com/api/buckets/${bucketId}`, { name: newBucketName });
            setBuckets(buckets.map(bucket => bucket.id === bucketId ? { ...bucket, name: newBucketName } : bucket));
            setEditingBucket(null);
        } catch (error) {
            console.error("Error updating bucket:", error);
        }
    };


    const handleDelete = (id) => {
        document.activeElement?.blur();
        setDeleteConfirm(id);
        setMenuOpen(null);
    };

    const confirmDelete = async () => {
        try {
            await axios.delete(`https://teams.tidyds.com/api/buckets/${deleteConfirm}`);
            setBuckets(buckets.filter(bucket => bucket.id !== deleteConfirm));
            setTasks(prev => {
                const updated = { ...prev };
                delete updated[deleteConfirm];
                return updated;
            });
            setDeleteConfirm(null);
        } catch (error) {
            console.error("Error deleting bucket:", error);
        }
    };

    const handleAddTask = (bucketId) => {
        document.activeElement?.blur();
        setNewTask({ name: "", dueDate: "", assignedTo: [], assigneeInput: "", bucketId });
    };

    const saveTask = async () => {
        document.activeElement?.blur();
        if (!newTask.name.trim() || !newTask.bucketId) return; // prevent empty save
        setLoading(true);
        try {
            const response = await axios.post("https://teams.tidyds.com/api/tasks", {
                name: newTask.name,
                due_date: newTask.dueDate,
                bucket_id: newTask.bucketId,
                priority: 'low',
                status: 'Not Started',
                assigned_users: newTask.assignedTo?.map(user => typeof user === "object" ? user.id : parseInt(user)) || [],
                show_notes: false,
                show_checklist: false,
                show_image: false,
            });

            const updatedTask = response.data;

            //Log generation for task create and sets due date
            const logs = [];
            logs.push(`Created this task "${updatedTask.name}"`);
 
            if (updatedTask.due_date) {
                logs.push(`Sets due date "${formatDate(updatedTask.due_date)}" of this task`);
            }
 
            // 🔹 Assigned users log
            if (newTask.assignedTo?.length > 0) {
                newTask.assignedTo.forEach(user => {
                    let userName;
                    if (typeof user === "object") {
                        userName = user.name;
                    } else {
                        const foundUser = users.find(u => u.id === parseInt(user));
                        userName = foundUser ? foundUser.name : `User(${user})`;
                    }
                    logs.push(`Assigned this task to ${userName}`);
                });
            }
 
            const description = logs.join(", ");
 
            sendLogToBackend({
                taskId: updatedTask.id,
                userId: currentUser.id,
                description
            });
 
            await fetchTaskUsers();
            toast.success("Task successfully added!");
        } catch (error) {
            console.error("Error adding task:", error);
            toast.error("Failed to add task.");
        } finally {
            setLoading(false);
            setNewTask({
                name: "",
                dueDate: "",
                assignedTo: [],
                assigneeInput: "",
                bucketId: null
            });
        }
        document.activeElement?.blur();
    };




    // Handle outside click
    useEffect(() => {
        const handleClickOutside = (event) => {
            document.activeElement?.blur();
            if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
                if (newTask.name.trim() && newTask.bucketId) {
                    saveTask();
                } else {
                    setNewTask({ name: "", dueDate: "", assignedTo: [], assigneeInput: "", bucketId: null });
                }
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [newTask, saveTask]);

    const normalizeStatus = (status) => {
        const map = {
          'not started': 'Not Started',
          'in progress': 'In Progress',
          'completed': 'Completed'
        };
        return map[status?.toLowerCase()] || 'Not Started';
    };


    const confirmTaskDelete = (taskId, bucketId) => {
        try {
            const bucketTasks = tasks[bucketId] || [];
            const index = bucketTasks.findIndex(t => t.id === taskId);
            if (index === -1) return;

            const taskToDelete = bucketTasks[index];

            // Remove it visually
            setTasks(prev => {
                const copy = [...prev[bucketId]];
                copy.splice(index, 1); // remove the task
                return {
                    ...prev,
                    [bucketId]: copy
                };
            });

            // Store it for undo
            setDeletedTask({ task: taskToDelete, bucketId, index });
            setShowUndo(true);

            // Auto-delete after 5 seconds
            setTimeout(async () => {
                setDeletedTask(prev => {
                    if (prev && prev.task.id === taskId) {
                        axios.delete(`https://teams.tidyds.com/api/tasks/${taskId}`)
                            .then(() => toast.success("Task permanently deleted!"))
                            .catch(() => toast.error("Failed to delete task permanently."))
                            .finally(() => {
                                setShowUndo(false);
                            });
                        return null; // clear deletedTask
                    }
                    return prev; // user already undid
                });
            }, 5000);

            toast.success("Task deleted! Undo available.");
        } catch (error) {
            console.error("Error deleting task:", error);
            toast.error("Failed to delete task.");
        } finally {
            setDeleteTaskConfirm(null);
        }
    };

    // Undo function
    const undoDelete = () => {
        if (!deletedTask) return; // safeguard
        
        setSelectedTask(null)
        setTasks(prev => {
            const copy = [...prev[deletedTask.bucketId]];
            copy.splice(deletedTask.index, 0, deletedTask.task); // restore at same position
            return {
                ...prev,
                [deletedTask.bucketId]: copy
            };
        });

        setDeletedTask(null);
        setShowUndo(false);
        toast.info("Task restored!");
    };


        const saveEditedTask = async (task, oldBucketId) => {
            document.activeElement?.blur();
            // Validate required fields
            if (!task.name) return alert("Task name cannot be empty");
            if (!task.bucket_id) return alert("Please select a bucket");

            
            setLoading(true)
            const toastId = toast.loading("Saving task...",{
                className: "my-loading-toast"
                });

            const payload = {
                name: task.name,
                bucket_id: task.bucket_id,
                status: task.status || null,
                priority: task.priority || null,
                notes: task.notes || "",
                description: task.description || "",
                start_date: task.start_date ? task.start_date : null,
                due_date: task.due_date ? task.due_date : null,
                checklist: task.checklist || [],
                attachments: task.attachments || [],
                comments: task.comments || [],
                assigned_users: task.assignedTo?.map(user => typeof user === "object" ? user.id : parseInt(user)) || [],
                show_notes:task.show_notes,
                show_checklist:task.show_checklist,
                show_image:task.show_image
            };

            try {
                const response = await axios.put(
                    `https://teams.tidyds.com/api/tasks/${task.id}`,
                    payload
                );
                const updatedTask = response.data;

                // Update state
                    setTasks(prev => {
                        const updatedBuckets = { ...prev };
                        const bucketId = updatedTask.bucket_id;

                        if (!updatedBuckets[bucketId]) updatedBuckets[bucketId] = [];

                        // Remove the task if it exists in this bucket
                        updatedBuckets[bucketId] = updatedBuckets[bucketId].filter(t => t.id !== updatedTask.id);

                        // Add the updated task
                        updatedBuckets[bucketId].push(updatedTask);

                        // 🔹 Sort by position in reverse
                        updatedBuckets[bucketId].sort((a, b) => b.position - a.position);

                        // Remove from old bucket if moved
                        if (oldBucketId && oldBucketId !== bucketId) {
                            updatedBuckets[oldBucketId] = updatedBuckets[oldBucketId].filter(t => t.id !== updatedTask.id);
                        }

                        return updatedBuckets;
                    })
                    
                document.activeElement?.blur();
                {assigningUser && await fetchTasks()}
                {assigningUser && await fetchTaskUsers()}
                {assigningUser && await fetchLogs()}
                toast.success("Task successfully updated!", { id: toastId });
                document.activeElement?.blur();
            } catch (error) {
                console.error("Error editing task:", error);
                if (error.response?.status === 422) {
                    toast.error("Validation failed! Check inputs.", { id: toastId });
                } else {
                    toast.error("Failed to update task.", { id: toastId });
                }
            }finally{
                toast.dismiss(toastId)
            }
            setLoading(false)
            setEditingTaskId(null);
            setAssigningUser(false)
        };

    const removedAssignee = async(task_id,user_id)=>{
              try {
                    if (removedAssignees.length > 0) {
                    await axios.post("https://teams.tidyds.com/api/task-user/remove-assignees", {
                        removed_assignees: removedAssignees
                    });
                    }
                    setRemovedAssignees([]); 
                } catch (err) {
                    console.error(err);
                }
        }


    const sendLogToBackend = async ({ taskId, userId, description }) => {
        if (!description) return; // Nothing changed, no log needed
        try {
            await fetch('https://teams.tidyds.com/api/logs', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                task_id: taskId,
                user_id: userId,
                description,
            }),
            });
        } catch (error) {
            console.error('Failed to create log:', error);
        }
    };

    
    const updateBucketOrder = async (bucket) => {
        try {
            await axios.put(`https://teams.tidyds.com/api/buckets/${bucket.id}/move`, {
                position: bucket.position
            });
        } catch (err) {
            console.error("Failed to update bucket order:", err);
        }
    };   

    

    const handleMoveLeft = (bucketId) => {
        const index = buckets.findIndex(b => b.id === bucketId);
        if (index > 0) {
            const newBuckets = [...buckets];
    
            // Swap the buckets with index
            [newBuckets[index], newBuckets[index-1]] = [newBuckets[index-1], newBuckets[index]];

            // Reassign position + index for all buckets
            const updatedBuckets = newBuckets.map((b, i) => ({
                ...b,
                position: i,
                index: i
            }));

            setBuckets(updatedBuckets);
    
            // Update both buckets in backend
            updateBucketOrder(updatedBuckets.find(b => b.id === bucketId));
            updateBucketOrder(updatedBuckets.find(b => b.id === newBuckets[index].id));
        }
        setMenuOpen(menuOpen === bucketId ? null : bucketId);
    };
    
    const handleMoveRight = (bucketId) => {
        const index = buckets.findIndex(b => b.id === bucketId);
        if (index < buckets.length - 1) {
            const newBuckets = [...buckets];
    
            // Swap visually
            [newBuckets[index], newBuckets[index+1]] = [newBuckets[index + 1], newBuckets[index]];

            // Reassign position + index for all buckets
            const updatedBuckets = newBuckets.map((b, i) => ({
                ...b,
                position: i,
                index: i
            }));

            setBuckets(updatedBuckets);
    
            // Update both buckets in backend
            updateBucketOrder(updatedBuckets.find(b => b.id === bucketId));
            updateBucketOrder(updatedBuckets.find(b => b.id === newBuckets[index].id));
        }
        setMenuOpen(menuOpen === bucketId ? null : bucketId);
    };        
    
    const toggleTaskStatus = async (task, bucketId) => {
        setLoading(true)
        const updatedStatus = task.status === 'Completed' ? 'Not Started' : 'Completed';
        
    
        try {
            // Send the PUT request to update the task status
            const response = await axios.put(`https://teams.tidyds.com/api/tasks/${task.id}`, {
                name: task.name,
                bucket_id: task.bucket_id,
                status: updatedStatus,
                start_date: task.start_date || null,
                due_date: task.due_date || null,
                notes: task.notes || '',
                description: task.description || '',
                checklist: task.checklist || [],
                attachments: task.attachments || [],
                comments: task.comments || [],
                assigned_users: task.assigned_users?.map(user =>
                    typeof user === 'object' ? user.id : parseInt(user)
                ) || []
            });
    
            const updatedTask = response.data;
    
            // Update tasks in the state with the updated task
            const updatedTasks = { ...tasks };
            updatedTasks[bucketId] = updatedTasks[bucketId].map(t =>
                t.id === task.id ? updatedTask : t
            );
    
            setTasks(updatedTasks);
        } catch (err) {
            console.error('Failed to update task status:', err);
        }
        setLoading(false)
    };     
    
    const taskIds = Array.isArray(tasks) 
    ? tasks.map(t => t.id) 
    : [];

    const RenderTask = ({task, bucketId, id}) => { 
        const isCompleted = String(task.status).toLowerCase() === 'completed';
        const myId = taskElementId(bucketId, task.id);
        const [checklist, setChecklist] = useState(task.checklist || []);
        const totalItems = checklist?.length || 0;
        const completedItems = checklist?.filter((item) => item.done).length || 0;
        const progressPercent = totalItems === 0 ? 0 : Math.round((completedItems / totalItems) * 100);

        const { attributes, listeners, setNodeRef, transform,transition, isDragging } =
        useSortable({
            id:myId,
                data: {
                type: "task",
                bucketId: bucketId,
                taskId: task.id,
                task: task   // 👈 this is the important one for DragOverlay
                },

            disabled: isCompleted, 
        });
        const isDueDateEnds = () => {
            if (!task?.due_date) return false;
 
            const dueDate = new Date(task.due_date);
            const today = new Date();
 
            // Clear time for both if you only care about date
            dueDate.setHours(0, 0, 0, 0);
            today.setHours(0, 0, 0, 0);
 
            return dueDate < today;
        };
        const style = {
               transform: CSS.Transform.toString(transform),
                transition,
                padding: "10px",
                marginBottom: "16px",
                borderRadius: "8px",
                visibility: isDragging ? "hidden" : "visible", 
                border:isDueDateEnds() ? "1px solid #d62828":"none"
        };


        const handleEditClick = (task) => {
            document.activeElement?.blur();
            setEditingTaskId(task.id);

            setTaskEdits({
                id: task.id, 
                bucket_id: task.bucket_id, 
                progress: task.status, 
                name: task.name,
                due_date: task.due_date,
                start_date: task.start_date || null,
                notes: task.notes || "",
                checklist: task.checklist || [],
                attachments: task.attachments || [],
                comments: task.comments || [],
                assigneeInput: "",

                // 🔹 Assigned Users from pivot or fallback to task.assigned_users
                assignedTo: taskUsers[task.id] || (task.assigned_users?.map(u => u.id.toString()) || []).map(String),

                // 🔹 Full User Objects
                assignees: (taskUsers[task.id] || []).map(userId =>
                    users.find(u => u.id.toString() === userId.toString())
                    )
                });

            setTaskMenuOpen(null);
            };

        const handleclickPopup = (task) => {

            setTaskEdits({
                id: task.id, 
                bucket_id: task.bucket_id, 
                progress: task.status, 
                name: task.name,
                due_date: task.due_date,
                start_date: task.start_date || null,
                notes: task.notes || "",
                checklist: task.checklist || [],
                attachments: task.attachments || [],
                comments: task.comments || [],
                assigneeInput: "",

                // 🔹 Assigned Users from pivot or fallback to task.assigned_users
                assignedTo: (taskUsers[task.id] || task.assigned_users?.map(u => u.id.toString()) || []).map(String),

                // 🔹 Full User Objects
                assignees: (taskUsers[task.id] || task.assigned_users?.map(u => u.id.toString()) || []).map(userId =>
                    users.find(u => u.id.toString() === userId.toString())
                )
                });

            setSelectedTask(prev => ({
                ...prev,
                assignedTo: (taskUsers[task.id] || task.assigned_users?.map(u => u.id.toString()) || []).map(String)
                }));
                document.activeElement?.blur();
            };

        
        const handleEditDate = (date) =>{
            document.activeElement?.blur();
            setTaskEdits(prev => ({
                ...prev,
                due_date: date ? date.toISOString().split("T")[0] : null ,
                showDueDate: !prev.showDueDate
            }))
        }   

        // Handle assignee input
        const handleAssigneeInput = async (e) => {
            document.activeElement?.blur();
            const value = e.target.value;
                setTaskEdits(prev => ({ ...prev, assigneeInput: value }));
                await fetchUserSuggestions(value); // only updates suggestions
        };

        // Add assignee
        const addAssignee = (user) => {
            document.activeElement?.blur();
            setAssigningUser(true)
            setTaskEdits(prev => ({
                ...prev,
                assignedTo: [...prev.assignedTo, user.id.toString()], // keep IDs only
                assignees: [...(prev.assignees || []), user], // keep full user objects
                assigneeInput: "", // clear search
                showAssign: !prev.showAssign,
            }));
            setShowAssigneeInput(false)
        };

        // Remove assignee
       const removeAssignee = (user) => {
            document.activeElement?.blur();
            setAssigningUser(true)
            setTaskEdits(prev => ({
                ...prev,
                assignedTo: prev.assignedTo.filter(id => id !== user.id.toString()), // remove ID
                assignees: (prev.assignees || []).filter(u => u.id !== user.id), // remove full user object
            }));
        };
             
        const filteredSuggestions = userSuggestions.filter(u => {
            const query = taskEdits.assigneeInput.toLowerCase().trim();

            // assignedTo is just IDs, so check if u.id is in there
            const inAssigned = taskEdits.assignedTo.some(
                id => id.toString() === u.id.toString()
            );

            // Match input against name or email
            const matches =
                u.name.toLowerCase().includes(query) ||
                u.email.toLowerCase().includes(query);

            return !inAssigned && matches;
        });

        const generateChecklistLogs = (oldChecklist, newChecklist) => {
            const logs = [];
            const oldMap = new Map(oldChecklist.map(item => [item.text, item]));

            newChecklist.forEach(newItem => {
                const oldItem = oldMap.get(newItem.text);

                if (oldItem && !oldItem.done && newItem.done) {
                    logs.push(`Checklist "${newItem.text}" is completed`);
                }else if (oldItem.done && !newItem.done) {
                    logs.push(`Checklist "${newItem.text}" is unchecked`);
                }

                if (!oldItem && newItem.done) {
                    logs.push(`Checklist "${newItem.text}" is completed`);
                }
            });

            return logs;
        };
        
        const updateChecklist = async (taskId, checklist) => {
        try {
            const response = await axios.put(`https://teams.tidyds.com/api/tasks/${taskId}`, {
                name: task.name,
                bucket_id: task.bucket_id,
                status: task.status,
                priority: task.priority,
                notes: task.notes,
                description: task.description,
                start_date: task.start_date,
                due_date: task.due_date,
                attachments: task.attachments,
                comments: task.comments,
                assigned_users: task.assignedTo,
                checklist: checklist,
                });

            const updatedTask = response.data;

            // Update state with new checklist
            setTasks((prev) => {
            const updatedBuckets = { ...prev };

            // Find the bucket that contains this task
            for (const bucketId in updatedBuckets) {
                updatedBuckets[bucketId] = updatedBuckets[bucketId].map((t) =>
                t.id === taskId ? { ...t, checklist: updatedTask.checklist } : t
                );
            }

            return updatedBuckets;
            });

        } catch (error) {
            console.error("Failed to update checklist:", error);
            if (error.response) {
            console.error("Server says:", error.response.data);

            }
        }
        };


        const toggleChecklistItem = async (index) => {
             const oldChecklist = checklist.map(item => ({ ...item })); // deep clone
            const updated = checklist.map((item, i) =>
                i === index ? { ...item, done: !item.done } : { ...item }
            );

            // update popup local state
            setChecklist(updated);

            // 🔹 update parent tasks state so Kanban board sees it
            setTasks(prev => {
                const updatedBuckets = { ...prev };
                for (const bId in updatedBuckets) {
                updatedBuckets[bId] = updatedBuckets[bId].map(t =>
                    t.id === task.id ? { ...t, checklist: updated } : t
                );
                }
                return updatedBuckets;
            });

            // log in background
            const logs = generateChecklistLogs(oldChecklist, updated);
            logs.forEach(log => {
                sendLogToBackend({
                taskId: task.id,
                userId: currentUser.id,
                description: log,
                }).catch(console.error);
            });

            // save in localStorage
            localStorage.setItem(`task_${task.id}_checklist`, JSON.stringify(updated));

            // backend sync later
            try {
                await updateChecklist(task.id, updated);
            } catch (err) {
                console.error("Checklist sync failed", err);
            }
        };



        
        

        return (     
        <div ref={setNodeRef}  style={style}  {...(!isCompleted ? attributes : {})}
          key={task.id}
          className={`task ${task.status === 'Completed' ? "completed-task" : ""}`}
          onClick={() => {
            editingTaskId !== task.id && setSelectedTask(task)
            editingTaskId !== task.id && handleclickPopup(task)
        }}
        >
          <div className="task-header" {...listeners} {...attributes}>
            <div className="taskcn">
              <input
                type="radio"
                className="radio-task"
                title="Do you want to complete it?"
                onChange={() => {}}
                checked={task.status === 'completed'}
                onClick={(e) => {
                e.stopPropagation();
                toggleTaskStatus(task, bucketId);
                }}
              />
              <strong className={task.status === 'completed' ? 'task-completed' : ''}>
                    {task.name}
              </strong>
            </div>
      
            <div className="menu-icon" onClick={(e) => {
              e.stopPropagation();
              toggleTaskMenu(task.id);
            }}>⋮</div>
            {taskMenuOpen === task.id && (
              <div className="dropdown-menu">
                <button onClick={(e) => {
                    e.stopPropagation();
                    document.activeElement?.blur();
                    handleEditClick(task);
                    }}>Edit</button>
                <button onClick={(e) => {
                    document.activeElement?.blur();
                    e.stopPropagation();
                    setDeleteTaskConfirm({ taskId: task.id, bucketId });
                }}>Delete</button>
              </div>
            )}  
          </div>
      
          {editingTaskId === task.id ? (
            <div className="new-task-form styled-task-box-edit">
                {/* Task Name Input */}
                <div className="task-input-section">
                    <input
                        type="text"
                        className="task-name-input"
                        placeholder="Enter a task name"
                        value={taskEdits.name}
                        onChange={(e) =>{
                            document.activeElement?.blur();
                            setTaskEdits({ ...taskEdits, name: e.target.value })
                        }
                        }
                        onKeyDown={(e) => e.stopPropagation()}
                        autoFocus
                    />
                </div>

                {/* Toggle Controls */}
                <div className="task-options">
                {/* 📅 Due Date Toggle */}
                <label
                    className="task-option"
                    onClick={() =>{
                    document.activeElement?.blur();
                    setTaskEdits((prev) => ({
                        ...prev,
                        showDueDate: !prev.showDueDate,
                    }))                           
                    }
                    }
                >
                    <img src="./calendar.png" alt="calendar" style={{width:"16px"}} />{" "}
                    {taskEdits.due_date
                    ? formatDate(taskEdits.due_date)
                    : "Set due date"}
                </label>

                {/* 📅 Due Date Input */}
                {taskEdits.showDueDate && (
                <DatePicker
                    selected={taskEdits.due_date}
                    onChange={handleEditDate}
                    dateFormat="dd/MM/yyyy"
                    placeholderText="Select a date"
                    className="border p-2 rounded"
                />
                )}
    
                 
                
                {/* 👤 Assign Toggle */}
                <div
                    className="task-option"
                    onClick={() =>{
                    document.activeElement?.blur();
                    setTaskEdits((prev) => ({
                        ...prev,
                        showAssign: !prev.showAssign,
                    }))
                    }
                    }
                >
                    <img src="./assigne.png" alt="calendar" style={{width:"16px"}} /> Assign
                </div>
                </div>


                {/* 👤 Assign User Section */}
                {taskEdits.showAssign && (
                <div className="assigned-user-input">
                    {/* Search Field */}
                    <input
                    type="text"
                    placeholder="Type email"
                    value={taskEdits.assigneeInput}
                    onChange={handleAssigneeInput}
                    onKeyDown={(e) => {
                        e.stopPropagation()
                        if (e.key === "Enter" && userSuggestions.length) {
                        const selected = userSuggestions[0];
                        if (
                            !taskEdits.assignedTo.includes(
                            selected.id.toString()
                            )
                        ) {
                            setTaskEdits((prev) => ({
                            ...prev,
                            assignedTo: [
                                ...prev.assignedTo,
                                selected.id.toString(),
                            ],
                            assigneeInput: "",
                            }));
                        }
                        e.preventDefault();
                        }
                    }}
                    autoFocus
                    />

                    {/* Suggestions Dropdown */}
                    {taskEdits.assignedTo && (
                    <div className="autocomplete-dropdown">
                        {/* Assigned Users Section */}
                        {taskEdits.assignees.length > 0 && (
                        <div className="dropdown-section">
                            <div className="dropdown-heading">Assigned Users</div>
                            {taskEdits.assignees.map((user) => (
                            <div key={`assigned-${user.id}`} className="autocomplete-item assigned">
                                <div className="profile-assign">
                                <img src={
                                        user.profile_pic.startsWith("http")
                                        ? user.profile_pic
                                        : `https://teams.tidyds.com${user.profile_pic}`
                                } alt={user.name} className="avatar rounded-circle" />
                                <div className="user-info">
                                    <div className="name">{user.name}</div>
                                    <div className="email">{user.email}</div>
                                </div>
                                </div>
                                {/* Remove button */}
                                <button
                                type="button"
                                className="remove-btn"
                                onClick={() => {
                                    setRemovedAssignees((prev) => [
                                    ...prev,
                                    { task_id: task.id, user_id: user.id },
                                    ]);
                                    removeAssignee(user);
                                }}
                                >
                                ×
                                </button>
                            </div>
                            ))}
                        </div>
                        )}

                        {/* Suggestions Section */}
                        {filteredSuggestions.length > 0 && (
                        <div className="dropdown-section">
                            <div className="dropdown-heading">Suggestions</div>
                            {filteredSuggestions.map((user) => (
                            <div
                                key={user.id}
                                className="autocomplete-item"
                                onClick={() => addAssignee(user)}
                            >
                                <img src={user.profile_pic} alt={user.name} className="avatar rounded-circle" />
                                <div className="user-info">
                                <div className="name">{user.name}</div>
                                <div className="email">{user.email}</div>
                                </div>
                            </div>
                            ))}
                        </div>
                        )}
                    </div>
                    )}

                </div>
                )}

                {/* Buttons */}
                <div className="row task-action">
                {loading ? <button className="btn btn-primary editsave-but col-6 w-100">Saving...</button>:<>
                <button
                    className="btn btn-primary editsave-but col-6"
                    onClick={() => {
                    document.activeElement?.blur();
                    if (!taskEdits.name.trim()) {
                        Swal.fire({
                            icon: 'warning',
                            title: 'Oops...',
                            text: 'Task name is required!',
                        });
                        return;
                    }
                    saveEditedTask(taskEdits);
                    removedAssignee(removedAssignees)
                    }}
                >
                    Save
                </button>
                <button
                    className="btn btn-secondary editcancel-but col-6"
                    onClick={() =>{
                        document.activeElement?.blur();
                        setEditingTaskId(null)
                    }
                    }
                >
                    Cancel
                </button></>}
                </div>
            </div>
            ) : (
            <>
                {/* View mode */}
                <p className="due-main-card" style={{marginTop:"8px",marginBottom:"0px", fontSize:"14px", lineHeight:"20px", fontWeight:"400", backgroundColor:isDueDateEnds()? "#d62828":"none",color:isDueDateEnds()?"white":"black",padding:isDueDateEnds()?"4px 8px":"0px 0px 6px 0px", borderRadius:isDueDateEnds()?"4px":"0px"}}>
                Due: {task.due_date ? formatDate(task.due_date) : "No due date"}
                </p>
                {task.show_notes &&
                <p style={{width:"230px",wordWrap:'break-word', margin:"8px 0px", fontWeight:"500"}}>
                    {task.description}
                </p>}
                {task.attachments && task.attachments.length > 0 && task.show_image && (
                    task.attachments.some(att => `https://teams.tidyds.com${att.url}` === task.show_image) && (
                        <div style={{ marginTop: "10px" }}>
                        <img
                            src={task.show_image} // the URL stored in show_image
                            alt="View"
                            style={{
                            width: "100%",
                            height: "auto",
                            cursor: "pointer",
                            }}
                            onClick={(e) => {
                            e.stopPropagation(); // prevent card click
                            window.open(task.show_image, "_blank"); // open the image in new tab
                            }}
                        />
                        </div>
                    )
                    )}

                    

                {task.show_checklist && (
                <>
                    {/* Checklist Progress Bar */}
                    {totalItems > 0 && (
                    <div className="mb-2">
                        <div className="progress" style={{ height: "6px", borderRadius: "3px", marginTop:"8px" }}>
                        <div
                            className="progress-bar"
                            role="progressbar"
                            style={{ width: `${progressPercent}%` }}
                            aria-valuenow={progressPercent}
                            aria-valuemin="0"
                            aria-valuemax="100"
                        />
                        </div>
                        <small>
                        {completedItems}/{totalItems} done
                        </small>
                    </div>
                    )}

                    {/* Checklist Items */}
                    {checklist?.length > 0 && (
                    <ul className="list-unstyled mb-0">
                        {checklist.map((item, idx) => (
                        <li key={idx} className="d-flex align-items-center mb-1">
                            <input type="checkbox" checked={item.done}  onClick={(e) => e.stopPropagation()}  
                               onChange={(e) =>{ 
                                    document.activeElement?.blur();
                                    e.stopPropagation() 
                                    toggleChecklistItem(idx)}} className="me-2 check-input" />
                            <span style={{ textDecoration: item.done ? "line-through" : "none",width:"180px",wordWrap:'break-word' }}>
                            {item.text}
                            </span>
                        </li>
                        ))}
                    </ul>
                    )}
                </>
                )}

                <div className="assigned-user-avatarss d-flex justify-content-between" style={{borderTop:"1px solid #cac4d0", paddingTop:"8px"}}>
                <div>
                    {task.assigned_users?.length ? (
                    task.assigned_users.map((user) => (
                    <img
                        key={user.id}
                        src={`https://teams.tidyds.com${user.profile_pic}`}
                        alt={user.email}
                        title={user.email}
                        className="user-avatarr"
                        style={{marginRight:"10px"}}
                    />
                    ))
                ) : (
                    <span>Unassigned</span>
                )}
                </div>
                </div>
            </>
            )}
        </div>
        )
    
    };
    
        
    const NewTaskForm = ({ newTask, setNewTask, wrapperRef }) => {
  const handleNameChange = (e) => {
    setNewTask(prev => ({ ...prev, name: e.target.value }));
  };

  const handleDateChange = (date) => {
    if (!date) {
      setNewTask(prev => ({ ...prev, dueDate: null }));
      return;
    }
    // store as YYYY-MM-DD string (your saveTask expects that)
    setNewTask(prev => ({ ...prev, dueDate: date.toISOString().split("T")[0] }));
    setShowDateInput(false);
  };

  const handleAssigneeInput = async (e) => {
    const value = e.target.value;
    setNewTask(prev => ({ ...prev, assigneeInput: value }));
    await fetchUserSuggestions(value);
  };

  const addAssignee = (user) => {
    setAssigningUser(true);
    setNewTask(prev => ({
      ...prev,
      assignedTo: [...prev.assignedTo, user.id.toString()],
      assignees: [...(prev.assignees || []), user],
      assigneeInput: ""
    }));
    setShowAssigneeInput(false);
  };

  const removeAssignee = (userId) => {
    setAssigningUser(true);
    setNewTask(prev => ({
      ...prev,
      assignedTo: prev.assignedTo.filter(id => id !== userId.toString()),
      assignees: (prev.assignees || []).filter(u => u.id.toString() !== userId.toString())
    }));
  };

  // suggestions excluding already assigned
  const filteredSuggestions = userSuggestions.filter(
    u => !newTask.assignedTo.includes(u.id.toString())
  );

  return (
    <div ref={wrapperRef} className="task new-task-form styled-task-box">
      <div className="task-input-section">
        <input
          type="text"
          className="task-name-input"
          style={{ marginTop: "10px" }}
          placeholder="Enter a task name * (required)"
          value={newTask.name}
          onChange={handleNameChange}
          autoFocus
        />
      </div>

      {/* bucket select (useful for list view where bucket is not implied) */}
      <div className="task-options" style={{ display: "flex", gap: 8 }}>
        <div className="task-option" onClick={() => setShowDateInput(prev => !prev)}>
          <img src="./calendar.png" alt="calendar" style={{ width: "16px" }} />
          {newTask.dueDate ? formatDate(newTask.dueDate) : "Set due date"}
        </div>

        {showDateInput && (
          <DatePicker
            selected={newTask.dueDate ? new Date(newTask.dueDate) : null}
            onChange={handleDateChange}
            dateFormat="dd/MM/yyyy"
            placeholderText="Select a date"
            className="border p-2 rounded"
          />
        )}

        <div className="task-option" onClick={() => setShowAssigneeInput(prev => !prev)}>
          <img src="./assigne.png" alt="assign" style={{ width: "16px" }} /> Assign
        </div>
      </div>

      {showAssigneeInput && (
        <div className="assigned-user-input">
          <input
            type="text"
            placeholder="Type name or email"
            value={newTask.assigneeInput}
            onChange={handleAssigneeInput}
            onKeyDown={(e) => {
              if (e.key === "Enter" && filteredSuggestions.length) {
                addAssignee(filteredSuggestions[0]);
                e.preventDefault();
              }
            }}
            autoFocus
          />

          {(newTask.assignees?.length > 0 || filteredSuggestions.length > 0) && (
            <div className="autocomplete-dropdown">
              {newTask.assignees?.length > 0 && (
                <div className="dropdown-section">
                  <div className="dropdown-heading">Assigned Users</div>
                  {newTask.assignees.map(user => (
                    <div key={`assigned-${user.id}`} className="autocomplete-item assigned">
                      <div className="profile-assign">
                        <img src={getAvatarUrl(user)} alt={user.name} className="avatar rounded-circle" />
                        <div className="user-info">
                          <div className="name">{user.name}</div>
                          <div className="email">{user.email}</div>
                        </div>
                      </div>
                      <button type="button" className="remove-btn" onClick={() => removeAssignee(user.id)}>×</button>
                    </div>
                  ))}
                </div>
              )}

              {filteredSuggestions.length > 0 && (
                <div className="dropdown-section">
                  <div className="dropdown-heading">Suggestions</div>
                  {filteredSuggestions.map(user => (
                    <div key={user.id} className="autocomplete-item" onClick={() => addAssignee(user)}>
                      <img src={getAvatarUrl(user)} alt={user.name} className="avatar rounded-circle" />
                      <div className="user-info">
                        <div className="name">{user.name}</div>
                        <div className="email">{user.email}</div>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          )}
        </div>
      )}

      <div className="n-task-b">
        {loading ? (
          <button className="add-task-button">Saving...</button>
        ) : (
          <button
            className="add-task-button"
            onClick={() => {
              // ensure bucket selected
              if (!newTask.bucketId) {
                toast.error("Please select a bucket");
                return;
              }
              saveTask();
            }}
          >
            Add task
          </button>
        )}
      </div>
    </div>
  );
};


    const closeDeletePopup = () => setDeleteConfirm(null);

    if (error) return <div>{error}</div>;

    const bucketsMap = {};
    buckets.forEach(bucket => {
    bucketsMap[bucket.id] = bucket.name;
    });

    const generateLogForTaskDrags = (fromBucketId,toBucketId) => {
        const logs = [];
        if (fromBucketId !== toBucketId) {
            const oldBucketName = bucketsMap[fromBucketId] || 'Unknown';
            const newBucketName = bucketsMap[toBucketId] || 'Unknown';
            logs.push(`Moved this task from "${oldBucketName}" to "${newBucketName}"`);
        }

        return logs.length ? logs.join(',') : null;
    };
    

    const handleDragEnd = async ({ active, over }) => {
        if (!active) return;
        // parse
        const from = parseElementId(active.id);
        const to = parseElementId(over?.id);

        // if dragged a bucket
        if (from.type === "bucket" && to.type === "bucket") {
           const fromIndex = buckets.findIndex(b => String(b.id) === String(from.bucketId));
            const toIndex = buckets.findIndex(b => String(b.id) === String(to.bucketId));
            if (fromIndex === -1 || toIndex === -1) return;

            const newBuckets = arrayMove(buckets, fromIndex, toIndex);

            // Reassign positions (descending or ascending – keep consistent)
            const updatedBuckets = newBuckets.map((b, i) => ({
                ...b,
                position: i
                }));

            setBuckets(updatedBuckets);

            // Persist to backend (drag reorder API)
            try {
                await fetch("https://teams.tidyds.com/api/buckets/reorder", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ ordered_ids: updatedBuckets.map(b => b.id) })
                });
            } catch (err) {
                console.error("Failed to persist bucket order", err);
            }

            setActiveBucket(null);
            return;
            }


        // dragging a task
        if (from.type !== "task") {
            setActiveTask(null);
            return;
        }

        // If dropped on a bucket area (over is bucket) -> append to end
        if (to.type === "bucket") {
            const fromBucketId = from.bucketId;
            const toBucketId = to.bucketId;

            // find task object
            const movedTask = (tasks[fromBucketId] || []).find(t => String(t.id) === String(from.taskId));
            if (!movedTask) {
            setActiveTask(null);
            return;
            }

            // remove from old bucket and insert at end of new bucket in UI
            setTasks(prev => {
            const copy = { ...prev };
            copy[fromBucketId] = [...(copy[fromBucketId] || [])].filter(t => String(t.id) !== String(movedTask.id));
            copy[toBucketId] = [...(copy[toBucketId] || []), movedTask];
            return copy;
            });

            // persist: send bucket and position (position = index in to bucket in UI)
            try {
            const position = (tasks[toBucketId] || []).length; // appended at end
            await fetch(`https://teams.tidyds.com/api/tasks/${movedTask.id}/move`, {
                method: "PUT",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ bucket_id: Number(toBucketId), position })
            });
            await fetchTasks();
            } catch (err) {
            console.error("Failed to update task move", err);
            }

            setActiveTask(null);
            return;
        }

        // Dropped on another task (to.type === 'task') -> compute target index and move within same or different bucket
        if (to.type === "task") {
            const fromBucketId = from.bucketId;
            const toBucketId = to.bucketId;
            const movedTaskId = from.taskId;
            const targetTaskId = to.taskId;

            const fromList = [...(tasks[fromBucketId] || [])];
            const toList = [...(tasks[toBucketId] || [])];

            const movedIndex = fromList.findIndex(t => String(t.id) === String(movedTaskId));
            const targetIndex = toList.findIndex(t => String(t.id) === String(targetTaskId));

            if (movedIndex === -1 || targetIndex === -1) {
            setActiveTask(null);
            return;
            }

            const movedTask = fromList[movedIndex];

            // if same column -> reorder using arrayMove
            if (fromBucketId === toBucketId) {
            const newList = arrayMove(fromList, movedIndex, targetIndex);
            setTasks(prev => ({ ...prev, [fromBucketId]: newList }));
            try {
                await fetch(`https://teams.tidyds.com/api/tasks/${movedTask.id}/move`, {
                method: "PUT",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ bucket_id: Number(fromBucketId), position: targetIndex })
                });
                await fetchTasks();
            } catch (err) {
                console.error("Failed to persist reorder", err);
            }
            } else {
            // different columns: remove from fromList and insert at targetIndex in toList
            fromList.splice(movedIndex, 1);
            toList.splice(targetIndex, 0, movedTask);
            setTasks(prev => ({ ...prev, [fromBucketId]: fromList, [toBucketId]: toList }));

            try {
                await fetch(`https://teams.tidyds.com/api/tasks/${movedTask.id}/move`, {
                method: "PUT",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ bucket_id: Number(toBucketId), position: targetIndex })
                });
                await fetchTasks();
            } catch (err) {
                console.error("Failed to persist cross-bucket move", err);
            }
            }

            setActiveTask(null);
            return;
        }

        setActiveTask(null);
        setDragTasks(null)
        };


        

       const handleDragOver = ({ active, over }) => {
        document.activeElement?.blur();
        const getBucketId = (task) => task.bucketId ?? task.bucket_id;
            if (!over) return;

            const activeId = active.id;
            const overId = over.id;

            if (activeId === overId) return;

            const isActiveATask = active.data?.current?.type === "task";
            const isOverATask = over.data?.current?.type === "task";
            const isOverABucket = over.data?.current?.type === "bucket";

    

    if (!isActiveATask) return;

    // work with drag preview state
    setDragTasks(prev => {
        const base = prev || tasks; // fall back to real tasks if no preview yet

        // ---- Case 1: Dragging over a task (just move visually within target bucket) ----
        if (isOverATask) {
    const overBucketId = over.data?.current?.bucketId;
    const fromBucketId = active.data.current.bucketId;
    const toBucketId = overBucketId || fromBucketId;
    
    const currentTask = active.data?.current.task;
    setDraggingTask(currentTask);

    const from = parseElementId(active.id);
    const to = parseElementId(over.id);

    const dedupe = (list) => {
        const seen = new Set();
        return list.filter((t) => {
            const key = `${t.id}-${t.bucket_id}`;
            if (seen.has(key)) return false;
            seen.add(key);
            return true;
        });
    };

    const fromList = dedupe(tasks[fromBucketId] || []);
    const toList = dedupe(tasks[toBucketId] || []);

    const activeIndex = fromList.findIndex(t => String(t.id) === String(from.taskId));
    const overIndex = toList.findIndex(t => String(t.id) === String(to.taskId));


    if (activeIndex === -1 || overIndex === -1) return prev;

    // 1️⃣ Remove from source
    const [movedTask] = fromList.splice(activeIndex, 1);

    // 2️⃣ Update bucket id
    movedTask.bucket_id = toBucketId;

    movedTask._isPlaceholder = true;

    // 3️⃣ Insert into destination list
    toList.splice(overIndex, 0, movedTask);

    return {
        ...base,
        [fromBucketId]: fromList,   // always remove from source
        [toBucketId]: toList,       // always insert into target
    };
}


        // ---- Case 2: Dragging over a bucket (append to end visually) ----
        if (isOverABucket) {
    const fromBucketId = active.data.current.bucketId;
    const toBucketId = over.data.current.bucketId;
    if (fromBucketId === toBucketId) return prev;

    const fromList = [...(base[fromBucketId] || [])];
    const toList = [...(base[toBucketId] || [])];

    const activeIndex = fromList.findIndex(
        t => String(t.id) === String(parseElementId(active.id).taskId)
    );
    if (activeIndex === -1) return prev;

    const [movedTask] = fromList.splice(activeIndex, 1);
    movedTask.bucketId = toBucketId;

    // Determine hover index
    const overTasks = toList; // array of tasks in target bucket
    const overTaskIndex = overTasks.findIndex(
        t => String(t.id) === over?.data?.current?.id?.split("-")[1]
    );

    if (overTaskIndex !== -1) {
        // Insert above hovered task
        toList.splice(overTaskIndex, 0, movedTask);
    } else {
        // Empty bucket or not hovering a task -> append to end
        toList.push(movedTask);
    }

    return {
        ...base,
        [fromBucketId]: fromList,
        [toBucketId]: toList,
    };
}


        return prev;
    });
};


    const Bucket = ({ bucket, index }) => {
        const Id = bucket.id;
        const bucketTasks = tasks[bucket.id] || [];
        
        // Separate active and completed tasks safely
        const validTasks = bucketTasks.filter(task => task && task.id);
        const activeTasks = validTasks.filter(task => task?.status?.toLowerCase() !== 'completed');
        const completedTasks = validTasks.filter(task => task?.status?.toLowerCase() === 'completed');
        
        const { attributes, listeners, setNodeRef, transform, transition } =
        useSortable({
            id: bucketElementId(bucket.id),
            data: {
                type: "bucket",
                bucketId: bucket.id,
                bucket: bucket,
            },
         });

         const style = {
            transform: CSS.Transform.toString(transform),
            transition,
            Width: "280px",
            padding: "10px",
            borderRadius: "10px",
        };

        return (
            <div
                ref={setNodeRef} style={style} 
                key={bucket.id}
                className={`p-0 bucket ${bucket.position === 0 ? 'position-left' : ''} ${bucket.position === 1 ? 'position-right' : ''}`}
                
            >
                {/* Bucket Header */}
                <div className="bucket-task-card">
                <div className="bucket-header" {...attributes} {...listeners}>
                    {editingBucket === bucket.id ? (
                        <input
                            type="text"
                            value={newBucketName}
                            onChange={e => setNewBucketName(e.target.value)}
                            onBlur={() => saveEditedBucket(bucket.id)}
                            onKeyDown={e => {
                                    if (e.key === "Enter"  && saveEditedBucket(bucket.id)) {
                                    saveEditedBucket(bucket.id);
                                    e.stopPropagation();
                                    }
                                    if (e.key === " " || e.key === "Spacebar"  && saveEditedBucket(bucket.id)) {
                                    e.stopPropagation();
                                    }
                                }}
                            autoFocus
                        />
                    ) : (
                        <>
                            <div className="bucket_name"><h5>{bucket.name}</h5></div>
                            <div className="menu-icon" onClick={() => toggleMenu(bucket.id)} style={{marginBottom:"10px", color:"#72757b"}}>⋮</div>
                            {menuOpen === bucket.id && (
                                <div className="dropdown-menu" ref={bucketMenuRef}>
                                    <button onClick={() =>{
                                        document.activeElement?.blur();
                                        handleEditBucket(bucket)   
                                    }}>Edit</button>
                                    <button onClick={() =>{
                                        document.activeElement?.blur();
                                        handleDelete(bucket.id)
                                    }}>Delete</button>
                                    <button onClick={() => {
                                        document.activeElement?.blur();
                                        handleMoveLeft(bucket.id)
                                    }}>Move Left</button>
                                    <button onClick={() => {
                                        document.activeElement?.blur();
                                        handleMoveRight(bucket.id)
                                    }}>Move Right</button>
                                </div>
                            )}
                        </>
                    )}
                </div>

                {/* Add Task Button */}
                <button className="add-task-btn" onClick={() => handleAddTask(bucket.id)}>+ Add Task</button>
                
                </div>
                {newTask.bucketId === bucket.id && (
                    <NewTaskForm newTask={newTask} setNewTask={setNewTask} wrapperRef={wrapperRef} />
                )}
                {/* Active Tasks */}
                <div className="task-list" >
                    {activeTasks.length === 0 ? (
                        activeTask ? 
                        <div className="empty-bucket-placeholder" ref={setNodeRef}>
                            Drop tasks here
                        </div>:<></>
                    ) : (
                        <SortableContext
                            id={`bucket-${bucket.id}-active`}
                            items={activeTasks.map(task => taskElementId(bucket.id, task.id))}
                            strategy={verticalListSortingStrategy}
                        >
                            {activeTasks
                            .filter(applyFilters)
                            .map(task => (
                                <RenderTask key={task.id} task={task} bucketId={bucket.id} />
                            ))}
                        </SortableContext>
                    )}
                </div>

                {/* Completed Tasks */}
                <div className="task-list completed-section">
                    <div
                        className="completed-header"
                        onClick={() => setOpenCompleted(prev => ({ ...prev, [bucket.id]: !prev[bucket.id] }))}
                        style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            cursor: 'pointer',
                            background: '#f5f5f5',
                            padding: '10px',
                            borderRadius: '6px',
                            fontWeight: 'bold'
                        }}
                    >
                        <p style={{ color: '#555' }}>Completed tasks</p>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                            <span>{completedTasks.length}</span>
                            <FontAwesomeIcon
                                style={{ color: '#555' }}
                                icon={openCompleted[bucket.id] ? faChevronUp : faChevronDown}
                            />
                        </div>
                    </div>

                    {openCompleted[bucket.id] && (
                        <div className="completed-task-list" style={{ marginTop: '10px' }}>
                        <SortableContext
                            items={completedTasks.map((task, i) => `${bucket.id}:${task.id}`)}
                            strategy={verticalListSortingStrategy}
                        >
                            {completedTasks.filter(applyFilters).map((task, index) =>
                                activeTask?.id === task.id ? null : (
                                    <RenderTask
                                        key={`${bucket.id}-${task.id}`}
                                        task={task}
                                        bucketId={bucket.id}
                                        index={index}
                                        data={{ ...task }}
                                        id={`${bucket.id}:${task.id}`}
                                    />
                                )
                            )}
                        </SortableContext>
                        </div>
                    )}
            </div>
            </div>
        );
};

    const collisionDetection = (args) => {
        const { active } = args;

        // If dragging a bucket, only check collisions against buckets
        if (active.id.startsWith("bucket-")) {
            return closestCenter({
            ...args,
            droppableContainers: args.droppableContainers.filter(c =>
                c.id.startsWith("bucket-")
            ),
            });
        }

        // Default for tasks
        return closestCenter(args);
    };
    
    return (
  viewMode === "board" ? (
    // -------- GRID VIEW --------
    <DndContext
      sensors={sensors}
      collisionDetection={collisionDetection}
      onDragStart={(event) => {
        document.activeElement?.blur();
        if (event.active.id.startsWith("bucket-")) {
          setIsDraggingBucket(true);
        }
        const parsed = parseElementId(event.active.id);
        if (parsed.type === "task") {
          const bucketId = parsed.bucketId;
          const taskId = parsed.taskId;
          const t = (tasks[bucketId] || []).find(x => String(x.id) === String(taskId));
          if (t) setActiveTask(t);
        } else if (parsed.type === "bucket") {
          const b = buckets.find(x => String(x.id) === String(parsed.bucketId));
          if (b) setActiveBucket(b);
        }
      }}
      onDragEnd={async (event) => {
        document.activeElement?.blur();
        setActive(null);
        setIsDraggingBucket(false);
        await handleDragEnd(event);
      }}
      onDragOver={(event) => {
        handleDragOver(event);
      }}
      onDragCancel={() => {
        document.activeElement?.blur();
        setActiveTask(null);
        setActiveBucket(null);
        setIsDraggingBucket(false);
      }}
    >
      <ScrollContainer
        className="kanban-scroll"
        horizontal
        ignoreElements={[".bucket", ".task"]}
        activationDistance={10}
        hideScrollbars="none"
      >
        <div
          className="kanban-board"
          ref={boardRef}
          style={{
            display: "flex",
            alignItems: "flex-start",
            height: "89vh",
          }}
        >
          <SortableContext
            items={buckets.map(b => bucketElementId(b.id))}
            strategy={horizontalListSortingStrategy}
          >
            {buckets.sort((b, a) => b.position - a.position).map((bucket, index) => (
              <Bucket key={bucket.id} bucket={bucket} index={index} />
            ))}
          </SortableContext>

          {/* Add new bucket */}
          <div className="add-bucket-container">
            {addingBucket ? (
              <div className="new-bucket-form">
                <input
                  type="text"
                  placeholder="Enter Bucket Name"
                  value={newBucketName}
                  className="n-b-f"
                  onChange={e => setNewBucketName(e.target.value)}
                  onBlur={addBucket}
                  style={{ fontSize: "16px", fontWeight: "400", lineHeight: "24px", border: "1px solid #bdbdbd", padding: "10px 16px" }}
                  onKeyDown={e => e.key === "Enter" && addBucket()}
                  autoFocus
                />
              </div>
            ) : (
              <button className="add-bucket-btn" onClick={() => setAddingBucket(true)}>
                <img src="./plus.png" alt="add" style={{ width: "14px", marginRight: "10px" }} /> Add New Bucket
              </button>
            )}
          </div>
        </div>

        {/* Undo delete toast */}
        {showUndo && (
          <div style={{ position: "fixed", bottom: 20, left: 20, background: "#5905b3ff", color: "#fff", padding: "8px 20px", borderRadius: "50px" }}>
            Task deleted
            <button
              onClick={undoDelete}
              style={{ marginLeft: "16px", borderRadius: "50px", background: "#fff", border: "none", color: "#000", padding: "4px 10px" }}
            >
              Undo
            </button>
          </div>
        )}

        {/* Confirm delete bucket */}
        {deleteConfirm !== null && (
          <div className="popup-overlay">
            <div className="delete-popup">
              <p>Are you sure you want to delete this bucket?</p>
              <button className="confirm-btn" onClick={confirmDelete}>Delete</button>
              <button className="cancel-btn" onClick={closeDeletePopup}>Cancel</button>
            </div>
          </div>
        )}

        {/* Confirm delete task */}
        {deleteTaskConfirm !== null && (
          <div className="popup-overlay">
            <div className="delete-popup">
              <p>Are you sure you want to delete this task?</p>
              <button
                className="confirm-btn"
                onClick={() => {
                  confirmTaskDelete(deleteTaskConfirm.taskId, deleteTaskConfirm.bucketId);
                }}
              >
                Delete
              </button>
              <button className="cancel-btn" onClick={() => setDeleteTaskConfirm(null)}>Cancel</button>
            </div>
          </div>
        )}
      </ScrollContainer>

      {/* Drag overlay */}
      <DragOverlay dropAnimation={null}>
        {activeTask ? (
          <div style={{
            padding: "12px",
            borderRadius: "8px",
            boxShadow: "0 6px 18px rgba(0,0,0,0.25)",
            background: "#fff",
            width: "320px",
            pointerEvents: "none"
          }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <strong>{activeTask.name}</strong>
              <span style={{ fontSize: 12, color: "#666" }}>
                {activeTask.due_date ? formatDate(activeTask.due_date) : ""}
              </span>
            </div>
            <div style={{ marginTop: 8 }}>
              <p style={{ margin: 0 }}>{activeTask.notes?.slice(0, 200)}</p>
            </div>
          </div>
        ) : activeBucket ? (
          <div style={{
            padding: "8px",
            borderRadius: "8px",
            background: "#fff",
            boxShadow: "0 6px 18px rgba(0,0,0,0.25)",
            width: "260px",
            pointerEvents: "none"
          }}>
            <strong>{activeBucket.name}</strong>
          </div>
        ) : null}
      </DragOverlay>

      {/* ✅ FIX: TaskDetailsPopup moved OUTSIDE the Bucket loop — renders once, not per-bucket */}
      {selectedTask && (
        <TaskDetailsPopup
            task={selectedTask} 
            setTasks={setTasks}
            setLogs={setLogs}
            buckets={buckets}
            onClose={() =>{
                document.activeElement?.blur();
                setSelectedTask(null)
            }}
            currentUser={currentUser}
            onTaskUpdate={saveEditedTask}
            shownImages={shownImages}
            setShownImages={setShownImages}
            userSuggestion={userSuggestions}
            showCard={showCard}
            selectedTask={setSelectedTask}
            saveLog={sendLogToBackend}
            logs={logs}
            users={userMap}
            taskEdits={taskEdits}
            setTaskEdits={setTaskEdits}
            showAssigneeInput={showAssigneeInput}
            setShowAssigneeInput={setShowAssigneeInput}
            taskUsers={taskUsers}
            allUsers={users}
            removedAssignee={removedAssignee}
            removeAssignees={removedAssignee}
            setRemovedAssignees={setRemovedAssignees}
            setAssigningUser={setAssigningUser}
        />
      )}
    </DndContext>
  ) : (
    // -------- LIST VIEW --------
    <ListView
  tasks={tasks}
  buckets={buckets}
  filters={filters}
  onAddTask={(bucketId) => setAddingTask(bucketId)}
  onTaskClick={(task) => setSelectedTask(task)}
  onTaskEdit={(task) => setSelectedTask(task)}
  onTaskDelete={(task) =>
    setDeleteTaskConfirm({ taskId: task.id, bucketId: task.bucket_id })
  }
/>


  )
);
};

export default KanbanBoard;